import React from 'react'

// material ui
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import FormHelperText from '@mui/material/FormHelperText'

// components
import LocationSelected from './LocationSelected'
import LocationMenu from './LocationMenu'
import LocationLabel from './LocationLabel'
import SoftCloseNotice from './SoftCloseNotice'

// decorators
import { hasSoftClose } from 'lib/cart/decorators/softClose'

const SelectLocation = props => {
  const {
    camper,
    session,
    cartProduct,
    locations,
    isMobile,
    inputErrors,
    setCartAcknowledgedSoftClose
  } = props

  // can't change location if there is only one choice
  const { editLocation, location } = cartProduct || { editLocation: true }

  // detect any product selection validation errors for this camper and session
  const errors = inputErrors.filter(
    e =>
      e.path[0] === 'attributes' &&
      e.path[1] === 'cart_products' &&
      e.path[2] === 'location_id' &&
      e.path[3] === camper.id &&
      e.path[4] === cartProduct &&
      cartProduct.product.id
  )

  return (
    <FormControl fullWidth error={!!errors.length}>
      <FormLabel sx={{ mb: 2 }}>
        1. <LocationLabel editLocation={editLocation} locations={locations} />
      </FormLabel>

      {errors.map(error => (
        <FormHelperText key={error.path}>{error.message}</FormHelperText>
      ))}

      {editLocation ? (
        <LocationMenu {...props} />
      ) : (
        location && <LocationSelected location={location} isMobile={isMobile} />
      )}

      {location && hasSoftClose(location, cartProduct && cartProduct.plan) && (
        <SoftCloseNotice
          location={location}
          session={session}
          plan={cartProduct && cartProduct.plan}
          acknowledged={cartProduct && cartProduct.acknowledgedSoftClose}
          onAcknowledge={acknowledged =>
            setCartAcknowledgedSoftClose({ camper, session, acknowledged })
          }
        />
      )}
    </FormControl>
  )
}

export default SelectLocation
